import vestImg from '@assets/images/Products/vest.png';
import bgTexture from '@assets/images/Products/header-bg.png';

export default function ProductsHero() {
  return (
    <section
      className="relative flex items-center overflow-hidden bg-[#0B0B0B] py-4 text-white md:py-6"
      style={{
        backgroundImage: `url(${bgTexture})`,
        backgroundAttachment: 'fixed',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* === Gradient Overlay === */}
      <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/40 to-transparent" />

      {/* === Main Container === */}
      <div className="container relative z-20 mx-auto flex max-w-max items-center justify-between gap-6 px-6 tracking-tighter md:max-w-6xl md:px-12 lg:gap-10 lg:px-16 2xl:max-w-[1380px] 2xl:px-20">
        {/* === Left: Text Content === */}
        <div
          data-aos="fade-up"
          className="w-full text-center md:w-[45%] md:text-left"
        >
          <h1 className="text-xl font-extrabold leading-tight sm:text-2xl md:text-3xl 2xl:text-4xl">
            <span className="text-[#FFBD59]">Protection</span>{' '}
            <span className="text-white">You Can Rely On.</span>
          </h1>

          <p className="mt-2 max-w-lg text-xs leading-relaxed text-gray-300 sm:text-sm md:mt-3 md:text-base">
            From the field to daily security needs, AeroComp delivers gear built
            for strength and safety.
          </p>
        </div>

        {/* === Right: Vest Image (Bigger) === */}
        <div
          data-aos="fade-up"
          className="hidden w-[60%] items-center justify-center md:flex"
        >
          <img
            src={vestImg}
            alt="AeroComp Tactical Vest"
            className="h-auto w-full max-w-[850px] scale-110 object-contain drop-shadow-2xl"
          />
        </div>
      </div>
    </section>
  );
}
